module.exports = __webpack_public_path__ + "img/Ora-Ani_Zug_kl.378e5fe3.jpg";